import React, { useContext, useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { doorDashApi } from 'api/doorDash';
import { goPuffApi } from 'api/goPuff';
import { UserContext } from 'contexts/UserContext';
import { DataTable, Notifications } from 'shared';

function IssueGoPuffCredits() {
    const [rows, setRows] = useState([]);
    const [creditReasons, setCreditReasons] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });
    const history = useHistory();
    const queryParameters = new URLSearchParams(window.location.search);
    const poNum = queryParameters.get('poNum');
    const { wholesaleAccount } = useContext(UserContext);
    const [api, setApi] = useState(wholesaleAccount.fbmAccountName === 'doordash' ? doorDashApi : goPuffApi);

    const getCreditReasons = async () => {
        const response = await api.getPurchaseOrderCreditReasons(poNum);
        if (response.status === false) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        setCreditReasons(response.data.rows ? response.data.rows : []);
    };

    // Load  table
    const getRows = async () => {
        const response = await api.getPurchaseOrderDetails(poNum);
        if (response.status === false) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        const rowsWithDefaults = (response.data?.rows ?? []).map((row) => ({
            ...row,
            numToCredit: 0,
            reason: '',
        }));

        setRows(rowsWithDefaults);
    };

    useEffect(() => {
        if (wholesaleAccount.fbmAccountName === 'doordash') {
            setApi(doorDashApi);
        } else {
            setApi(goPuffApi);
        }
    }, [wholesaleAccount]);

    useEffect(() => {
        if (wholesaleAccount) {
            getRows();
            getCreditReasons();
        }
    }, [api]);

    const handleReviewItems = () => {
        const reviewRows = rows
            .map((row) => {
                if (row.numToCredit > 0 && row.reason !== '') {
                    return {
                        ...row,
                        dollarToCredit: parseFloat((row.pricePerSKU * row.numToCredit).toFixed(2)),
                    };
                }
                return row;
            })
            .filter((row) => row.dollarToCredit > 0);

        if (reviewRows.length > 0) {
            history.push('/gopuff/review-po-credits', { rows: reviewRows });
        } else {
            setNotification({ text: 'No entries found for review. Must have number and reason', level: 'error' });
        }
    };

    const columns = [
        { accessor: 'poNum', Header: 'PO#' },
        { accessor: 'microFC', Header: 'GP MFC' },
        { accessor: 'deliveryDate', Header: 'Delivery Date' },
        { accessor: 'externalSKU', Header: 'External SKU' },
        { accessor: 'name', Header: 'Product Name' },
        { accessor: 'numOrdered', Header: '# Ordered' },
        { accessor: 'pricePerSKU', Header: 'Price Per SKU' },
        { accessor: 'numToCredit', Header: '# Credit', editable: true },
        { accessor: 'reason', Header: 'Reason', editable: true, editProps: { type: 'select', options: creditReasons } },
    ];

    return (
        <div>
            <h1>Issue {wholesaleAccount.companyName} Credits</h1>
            <Notifications options={notification} />
            <div>
                <DataTable
                    columns={columns}
                    data={rows}
                    editable
                    saveEdit={async ({ field, id, row, value }) => {
                        if (field === 'numToCredit') {
                            if (value > row.numOrdered) {
                                setNotification({
                                    text: 'Num Credit can’t be higher than Num Ordered',
                                    level: 'error',
                                });
                                return;
                            }
                        }

                        const updatedRows = rows.map((r) => {
                            if (r.externalSKU === row.externalSKU) {
                                return { ...r, [field]: value };
                            }
                            return r;
                        });
                        setRows(updatedRows);
                    }}
                />
            </div>
            <Button variant="contained" color="primary" onClick={handleReviewItems} style={{ marginTop: '20px' }}>
                Review Credits
            </Button>
        </div>
    );
}

export { IssueGoPuffCredits };
